import { Controller } from "@hotwired/stimulus"

// Counts up from the moment the workout started.
//
// The elapsed time is derived from startedAt on every tick rather than kept in
// a counter, so leaving the page, reloading, or the PWA being suspended in the
// background never drifts the clock.
export default class extends Controller {
  static targets = ["display"]
  static values = { startedAt: String }

  connect() {
    this.render()
    this.timer = setInterval(() => this.render(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  render() {
    if (!this.hasDisplayTarget) return
    this.displayTarget.textContent = this.formatted(this.elapsedSeconds())
  }

  elapsedSeconds() {
    const started = Date.parse(this.startedAtValue)
    if (Number.isNaN(started)) return 0
    return Math.max(0, Math.floor((Date.now() - started) / 1000))
  }

  // Hours only appear once the workout passes the hour mark.
  formatted(total) {
    const hours = Math.floor(total / 3600)
    const minutes = Math.floor((total % 3600) / 60)
    const seconds = total % 60
    const pad = (n) => String(n).padStart(2, "0")

    return hours > 0
      ? `${hours}:${pad(minutes)}:${pad(seconds)}`
      : `${pad(minutes)}:${pad(seconds)}`
  }
}
